import React from "react";
import {Redirect} from "react-router-dom";
import Home from "./containers/Home/Home";
import NotFound from "./containers/404"

import { AsyncComponent } from 'asyncComponent.js';



const asyncJustin = AsyncComponent(
    () => import(/* webpackChunkName: "justin" */'./containers/Justin/Justin'));
const asyncFiles = AsyncComponent(
    () => import(/* webpackChunkName: "files" */'./containers/Files/Files'));
const asyncMint = AsyncComponent(
    () => import(/* webpackChunkName: "mint" */'./containers/Mint/Mint'));
const asyncView = AsyncComponent(
    () => import(/* webpackChunkName: "view" */'./containers/Files/ViewFile'));

export const routes = [
  {
    path: "/",
    label: "Home",
    icon: "fa",
    component: Home
  },
  {
    path: "/justin",
    label: "Justin",
    icon: "fa",
    component: asyncJustin
  },
  {
    path: "/files",
    label: "Files",
    icon: "fa",
    component: asyncFiles
  },
  {
    path: "/mint",
    label: "Mint",
    icon: "fa",
    component: asyncMint
  },
  {
    path: "/view/:id",
    label: "View",
    icon: "fa",
    component: asyncView
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '*',
    component: () => <Redirect to="/"/>,
  }
];

